import React from 'react'
import { authRoles } from '../../auth/authRoles'

const faqRoutes = [
    {
        path: '/faq',
        component: React.lazy(() => import('./cadastros/lista/Table')),
        auth: authRoles.admin,
        exact: true,
    },
    {
        path: '/faq/cadastro',
        component: React.lazy(() => import('./cadastros/form/Form')),
        auth: authRoles.admin,
        exact: true,
    },
    {
        path: '/faq/visualizar',
        component: React.lazy(() => import('./cadastros/visualizar/Form')),
        auth: authRoles.admin,
        exact: true,
    },
]

export default faqRoutes
